import { render, staticRenderFns } from "./FractionsModal.vue?vue&type=template&id=814bfd0a&scoped=true"
import script from "./FractionsModal.vue?vue&type=script&lang=js"
export * from "./FractionsModal.vue?vue&type=script&lang=js"
import style0 from "./FractionsModal.vue?vue&type=style&index=0&id=814bfd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814bfd0a",
  null
  
)

export default component.exports